import modules from "./store";

import { NAV_ITEMS_MODE } from "@/constants";
import { getFlagsConfig } from "@/config/flagsConfig";
import {
  MSP_NAV_ITEMS,
  CUSTOMER_NAV_ITEMS,
  CONNECTIONS_V2_NAV_CHILD,
} from "./constants";

const SettingsModule = ({ _app, store, registerNavItems }) => {
  // Stores
  store.registerModule("sso", modules.sso);

  // Nav Items
  registerNavItems(NAV_ITEMS_MODE.MSP, MSP_NAV_ITEMS);

  const customerNavItems = CUSTOMER_NAV_ITEMS.map((item) => ({
    ...item,
    children: getFlagsConfig().CONNECTIONS_V2
      ? [...item.children, CONNECTIONS_V2_NAV_CHILD]
      : item.children,
  }));
  registerNavItems(NAV_ITEMS_MODE.CUSTOMER_ADMIN, customerNavItems);
};

export { SettingsModule };

export default {};
